import React, { useState } from "react";
import { factory } from "typescript";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  postDataPage,
  setPageNo,
  setPageSize,
} from "../../../redux/learningsSlice";
import { Link } from "react-router-dom";
import { Tlearning } from "../../../type/learning";
// import { MonthAsByDate } from '../../../utls/date';
import { MINIO } from "../../../data/data";
import { FiYoutube } from "react-icons/fi";

interface ScrollItemLearningProps {
  keyword: string;
  fix?: boolean;
}

const ScrollItemLearning = (props: ScrollItemLearningProps) => {
  const { keyword, fix = factory } = props;
  const [loading, setLoading] = useState(false);
  //   const [hasMore, ] = useState(true);
  const { learningsPage, totalRows, pageNo } = useSelector(
    (state: RootState) => state.reducer.learnings
  );

  const dispatch = useDispatch<any>();

  const getLearningList = async (page: number, pageSize: number) => {
    const params = {
      pageNo: 0,
      pageSize: 10,
      sortType: "DESC",
      filter: [
        {
          key: "name",
          value: keyword,
          operation: "MATCH",
          conjunction: "or",
        },
        {
          key: "content",
          value: keyword,
          operation: "MATCH",
          conjunction: "or",
        },
        {
          key: "content_plain",
          value: keyword,
          operation: "MATCH",
          conjunction: "or",
        },
        {
          key: "active",
          value: true,
          operation: "EQUAL",
          conjunction: "and",
        },
      ],
    };
    dispatch(postDataPage(params));
    dispatch(setPageNo(page));
    dispatch(setPageSize(pageSize));
  };

  const handleScroll = async (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

    if (
      scrollHeight - scrollTop === clientHeight &&
      !loading &&
      !(totalRows === learningsPage.length)
    ) {
      setLoading(true);
      getLearningList(pageNo + 1, 10);
      setLoading(false);
    }
  };

  return (
    <>
      <div
        onScroll={handleScroll}
        className={` ${
          !fix ? "max-h-[calc(100vh-150px)] overflow-auto" : "mb-[100px]"
        } `}
      >
        {learningsPage.map((item: Tlearning, index: number) => {
          const text = item.content_plain || "";
          const plain = text.substring(0, 100);
          return (
            <div key={index} className="flex mb-4">
              <div className="w-[150px] bg-gray-50 text-cente rounded-sm">
                <Link to={`/admin/learning/${item.slug}`}>
                  <img
                    src={`${MINIO}/${item.thumbnail}`}
                    className=""
                    alt={item.name}
                  />
                </Link>
              </div>
              <div className="w-full ml-3">
                <Link to={`/admin/learning/${item.slug}`}>
                  <h2 className="text-[13px] font-medium block">{item.name}</h2>
                </Link>
                <span className="flex items-center mr-2 mb-1 gap-1 text-[10px] text-gray-400">
                  <FiYoutube className="text-[12px]" />
                  {item?.learningAssetsVideos?.length || 0} videos
                </span>
                <p className="text-[11px] text-justify">{plain}...</p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ScrollItemLearning;
